import { useQuery } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import { ApiError, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { ResolvedUsageGuide } from "../../productUsageGuides.types";
import { requestResolvedUsageGuide } from "./resolvedUsageGuide.request";

const useResolvedUsageGuide = (
  productId: string,
  options?: QueryOptions<ResolvedUsageGuide | null, ApiServiceError<ApiError>>
) => {
  const { data, ...rest } = useQuery({
    queryKey: ["product-usage-guides", "resolved", productId],
    queryFn: async () => await requestResolvedUsageGuide(productId),
    enabled: Boolean(productId),
    onError: toastServerError,
    ...options
  });

  return { resolvedGuide: data ?? null, ...rest };
};

export default useResolvedUsageGuide;
